//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
//components
import { FormsStack } from 'theme/elements/Forms';
import { InfoCard } from 'theme/elements/Cards';
import { FormHeader1 } from 'theme/elements/Headers';
import { CenteredText } from 'theme/elements/Content';
//mui
import { Box, Stack } from '@mui/system';
import { Button } from '@mui/material';

export default function Step4() {
	const t = useAppSelector(selectTranslations);
	return (
		<FormsStack>
			<InfoCard>
				<CenteredText>
					<FormHeader1
						title={t('card.beneficiary.title.beneficiary_created')}
						text={t('message.success.beneficiary_created')}
					/>
				</CenteredText>
			</InfoCard>
			<Box justifyContent="space-between" display="flex">
				<Button variant="text" onClick={() => {}}>
					{t('portal.actions.done')}
				</Button>
				<Stack flexDirection="row" gap={2}>
					<Button variant="outlined" onClick={() => {}}>
						{t('portal.actions.view_profile')}
					</Button>
					<Button variant="contained" onClick={() => {}}>
						{t('portal.actions.pay')}
					</Button>
				</Stack>
			</Box>
		</FormsStack>
	);
}
